const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class MilitaryAlliance extends Pact {
    constructor() {
        super(
            Age.Age3,
            PactNames.MilitaryAlliance,
            "Both civilizations add +3 to their military. This pact ends if one attacks the other.",
            {}
        )
    }
}

module.exports = MilitaryAlliance;